<template>
  <v-container
    class="qr-preview"
    fluid
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="6"
        class="text-center"
      >
        <h2 class="title">
          QR Code do Vendedor
        </h2>
        <p class="subtitle">
          {{ targetUrl }}
        </p>

        <v-card
          class="pa-6 qr-card"
          outlined
        >
          <div
            v-if="qrDataUrl"
            class="qr-wrapper"
          >
            <img
              :src="qrDataUrl"
              alt="QR Code"
              class="qr-image"
            />
          </div>
          <v-progress-circular
            v-else-if="loading"
            indeterminate
            color="primary"
          />
          <div
            v-else
            class="error"
          >
            {{ error || 'QR Code não disponível' }}
          </div>
        </v-card>

        <div class="actions">
          <v-btn
            outlined
            color="primary"
            class="mr-2"
            @click="goBack"
          >
            Voltar
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :disabled="!qrDataUrl"
            @click="printPage"
          >
            Imprimir
          </v-btn>
          <v-btn
            color="info"
            :disabled="!qrDataUrl"
            @click="downloadImage"
          >
            Baixar PNG
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'QrCodePreview',

  data() {
    return {
      qrDataUrl: '',
      loading: false,
      error: '',
    }
  },

  computed: {
    vendorId() {
      return this.$route.params.id || ''
    },
    targetUrl() {
      return this.vendorId ? `https://campanhascnh.motocasystems.com.br/${this.vendorId}` : ''
    },
  },

  watch: {
    vendorId: {
      immediate: true,
      handler() {
        this.generateQr()
      },
    },
  },

  methods: {
    async generateQr() {
      if (!this.targetUrl) {
        this.error = 'ID do vendedor não informado.'
        this.qrDataUrl = ''

        return
      }

      this.loading = true
      this.error = ''

      try {
        this.qrDataUrl = await QRCode.toDataURL(this.targetUrl, {
          width: 320,
          margin: 1,
        })
      } catch (err) {
        console.error('Erro ao gerar QR Code', err)
        this.error = 'Não foi possível gerar o QR Code.'
        this.qrDataUrl = ''
      } finally {
        this.loading = false
      }
    },

    printPage() {
      window.print()
    },

    goBack() {
      this.$router.back()
    },

    downloadImage() {
      if (!this.qrDataUrl) return

      const link = document.createElement('a')
      link.href = this.qrDataUrl
      link.download = `qr-${this.vendorId || 'vendedor'}.png`
      link.click()
    },
  },
}
</script>

<style scoped>
.qr-preview {
  min-height: 100vh;
  display: flex;
  align-items: center;
  background: #1f1a35;
  color: #fff;
}

.title {
  font-weight: 700;
  font-size: 28px;
  margin-bottom: 8px;
}

.subtitle {
  font-size: 14px;
  color: #c8c5d4;
  word-break: break-all;
}

.qr-card {
  background: #2a2342;
  border-color: rgba(255, 255, 255, 0.1);
}

.qr-wrapper {
  display: flex;
  justify-content: center;
}

.qr-image {
  width: 240px;
  height: 240px;
}

.error {
  color: #ff8080;
}

.actions {
  margin-top: 24px;
  display: flex;
  justify-content: center;
}

@media print {
  .subtitle,
  .actions,
  .v-card__actions,
  button,
  .v-btn {
    display: none !important;
  }

  .qr-preview {
    background: #fff;
    color: #000;
  }

  .qr-card {
    box-shadow: none;
    border: none;
    background: #fff;
  }

  .title {
    margin-bottom: 12px;
    color: #000;
  }
}
</style>
